// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@synd/App/SharedStyles/CartLineSharedStyles";
import { orderLinesListStyles } from "@synd/Overrides/Components/OrderLinesList";
import LinkReorder from "@synd/XDL/Icons/LinkReorder";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    height: "99px",
    width: "99px",
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.xSmall.lineHeight};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...mergeWithCss(cartLineSharedStyles.addToListLink, {
        css: css`
            margin-top: 0;
        `,
    }),
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    qtyLabelNotEditable: {
        css: css`
            display: block;
            margin-bottom: 0;
            ${xScreen("lte", "md")} {
                margin-bottom: 4px;
            }
        `,
    },
};

orderLinesListStyles.qtyShippedField = {
    qtyLabelNotEditable: {
        css: css`
            display: block;
            margin-bottom: 0;
            padding-top: 4px;
            ${xScreen("lte", "md")} {
                margin-bottom: 4px;
                padding-top: 12px;
            }
        `,
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div {
                float: right;
                width: 100%;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.xSmall.lineHeight};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.productOrderPriceContainer = {
    css: css`
        @media print {
            display: block;
            margin-left: 24px;
        }
    `,
};

orderLinesListStyles.imageBadges = {
    container: {
        css: css`
            margin-top: 8px;
        `,
    },
};

orderLinesListStyles.rtPriceWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding-top: 8px;
        gap: 2px;
        ${xScreen("lte", "md")} {
            padding-top: 12px;
        }
        > div {
            display: flex;
            gap: 4px;
        }
    `,
};

orderLinesListStyles.rtPriceHeading = {
    color: "common.ui4",
    size: fontConfig.xxSmall.size,
    lineHeight: fontConfig.xxSmall.lineHeight,
    weight: fontConfig.weight.regular,
};

orderLinesListStyles.rtPriceText = orderLinesListStyles.rtUnitOfMeasure = {
    color: "common.ui4",
    size: fontConfig.xSmall.size,
    lineHeight: fontConfig.xSmall.lineHeight,
    weight: fontConfig.weight.regular,
};

orderLinesListStyles.reorderCartLineIcon = {
    variant: "link" as any,
    icon: {
        src: LinkReorder,
        position: "left",
    },
    css: css`
        display: flex;
        align-items: flex-start;
        margin-top: 8px;
    `,
};
orderLinesListStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: auto;
        ${xScreen("lte", "md")} {
            margin-top: 12px;
            flex-direction: row;
            justify-content: space-between;
        }
    `,
};
